import { useImageStore } from "./images.store";
import type { ImageItem } from "./ImageItem";

/**
 * Returns the data that should be copied to the clipboard
 * when the user copies an image.
 * (includes the image data)
 * @param image The image to copy
 */
export function getImageCopyData(image: ImageItem) {
  const data = [];

  const imageStore = useImageStore();
  const mediaData = imageStore.mediaData[image.id];

  const copyableImage: ImageItem = {
    ...image,
    data: mediaData
  };
  data.push(copyableImage);

  return data;
}
